import React, { Component } from 'react';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import ModalSearch from '../../components/Modal/ModalSearch';
import ModalMenu from '../../components/Modal/ModalMenu';
import AccountComponent from '../../components/Account/accountComponent';

class Account extends Component {
    render() {
        return (
            <div className="main">
                <Header/>
                <AccountComponent/>
                <Footer/>
                <ModalSearch />
                <ModalMenu />
            </div>
        );
    }
}

export default Account;